import axiosInstance from "./api_helper";

const supplierProductService = {
    search: async (query) => {
        return axiosInstance.post(`/api/suppliersProducts/search`, JSON.stringify(query));
    },
    delete: async (id) => {
        return axiosInstance.delete(`/api/suppliersProducts/${id}`);
    },
    save: async (stock) => {
        return axiosInstance.post(`/api/suppliersProducts`, JSON.stringify(stock));
    },
    update: async (payload) => {
        return axiosInstance.put(`/api/suppliersProducts/${payload.id}`, JSON.stringify(payload.supplier));
    },
    

};
export default supplierProductService;